const EXPORT_SNAPSHOTS_STORAGE_KEY = 'itest_export_snapshots';
const EXPORT_SNAPSHOTS_MAX_LENGTH = 100;

export interface ItestExportSnapshot {
  timestamp: number;
  riasec: [number, number, number, number, number, number];
  accuracy: number;
  favoriteProfessionIds: string[];
  testMode: string;
  professionsFilter: string;
}

export function getExportSnapshots(): ItestExportSnapshot[] {
  try {
    const data = localStorage.getItem(EXPORT_SNAPSHOTS_STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function getExportSnapshotByTimestamp(
  timestamp: number,
): ItestExportSnapshot | undefined {
  return getExportSnapshots().find(
    (snapshot) => snapshot.timestamp === timestamp,
  );
}

export function saveExportSnapshot(snapshot: ItestExportSnapshot): void {
  const snapshots = getExportSnapshots();
  snapshots.push(snapshot);

  if (snapshots.length > EXPORT_SNAPSHOTS_MAX_LENGTH) {
    snapshots.splice(0, snapshots.length - EXPORT_SNAPSHOTS_MAX_LENGTH);
  }

  localStorage.setItem(EXPORT_SNAPSHOTS_STORAGE_KEY, JSON.stringify(snapshots));
}

export function clearExportSnapshots(): void {
  localStorage.removeItem(EXPORT_SNAPSHOTS_STORAGE_KEY);
}

export function buildPdfExportUrl(snapshot: ItestExportSnapshot): string {
  const params = new URLSearchParams({
    riasec: snapshot.riasec.join(','),
    acurracy: String(snapshot.accuracy),
    favprofs: snapshot.favoriteProfessionIds.join(','),
    testMode: snapshot.testMode,
    professionsFilter: snapshot.professionsFilter,
  });

  return `/create-pdf?${params.toString()}`;
}
